import { Alignment, Direction } from '../../LoginSocialBar.types';

export const flexAlignMap = {
  [Direction.LTR]: {
    [Alignment.Left]: 'flex-start',
    [Alignment.Center]: 'center',
    [Alignment.Right]: 'flex-end',
  },
  [Direction.RTL]: {
    [Alignment.Left]: 'flex-end',
    [Alignment.Center]: 'center',
    [Alignment.Right]: 'flex-start',
  },
} as const;
